<template>
  <div>
    <!-- PC导航 -->
    <div class="web-nav target action">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/images/1-25011420294O27.png" alt="南京华合半导体">
        </router-link>
      </div>
      <div class="web-navers">
        <dl>
          <h3><router-link to="/" exact>网站首页</router-link></h3>
        </dl>
        <dl>
          <h3><router-link to="/services">服务介绍</router-link></h3>
          <h4>
            <router-link to="/services/products?menu=器件模型提取&type=4">器件模型提取</router-link>
            <router-link to="/services/products?menu=PDK开发&type=5">PDK开发</router-link>
            <router-link to="/services/products?menu=IP设计服务&type=6">IP设计服务</router-link>
            <router-link to="/services/products?menu=IP流片&type=7">IP流片</router-link>
            <router-link to="/services/products?menu=整晶圆测试与挑片&type=8">整晶圆测试与挑片</router-link>
            <router-link to="/services/products?menu=芯片微组装&type=9">芯片微组装</router-link>
            <router-link to="/services/products?menu=货架IP&type=10">货架IP</router-link>
          </h4>
        </dl>
        <dl>
          <h3><router-link to="/news">新闻中心</router-link></h3>
        </dl>
        <dl>
          <h3><router-link to="/about">关于我们</router-link></h3>
          <h4>
            <router-link to="/about">公司概况</router-link>
            <router-link to="/about/list?menu=核心优势&type=2">核心优势</router-link>
            <router-link to="/about/list?menu=合作案例&type=3">合作案例</router-link>
          </h4>
        </dl>
        <dl>
          <h3><router-link to="/contact">联系我们</router-link></h3>
        </dl>
        <!-- <select class="ignore" style="height: 60px; outline: none; border: none; color: #555; font-size: 15px;" @change="changeLanguage($event)">
          <option value="chinese_simplified">简体中文</option>
          <option value="english">English</option>
        </select> -->
      </div>
      <div class="web-navright"></div>
    </div>

    <!-- 移动端导航 -->
    <header class="h5-naver target action drawer--right" :class="{ 'drawer-open': menuOpen }">
      <div class="html5">
        <k><router-link to="/"><img src="@/assets/images/1-25011420294O27.png"></router-link></k>
        <button type="button" class="drawer-toggle drawer-hamburger" @click="toggleMenu">
          <span class="drawer-hamburger-icon"></span>
        </button>
        <nav class="drawer-nav" role="navigation">
          <ul class="drawer-menu">
            <li><router-link class="drawer-menu-item" to="/" @click.native="menuOpen = false">网站首页</router-link></li>
            <li><router-link class="drawer-menu-item" to="/services" @click.native="menuOpen = false">服务介绍</router-link></li>
            <li><router-link class="drawer-menu-item" to="/news" @click.native="menuOpen = false">新闻中心</router-link></li>
            <li><router-link class="drawer-menu-item" to="/about" @click.native="menuOpen = false">关于我们</router-link></li>
            <li><router-link class="drawer-menu-item" to="/contact" @click.native="menuOpen = false">联系我们</router-link></li>
            <!-- <li><a class="ignore">简体中文</a></li>
            <li><a class="ignore">English</a></li> -->
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'WebNav',
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    changeLanguage(event) {
      const lang = event.target.value
      if (typeof translate !== 'undefined') {
        if (lang === 'english') {
          // 切换到英文
          translate.to = 'english'
          translate.storage.set('to', 'english')
          translate.execute()
        } else {
          // 切换到中文 - 清除翻译缓存
          translate.to = ''
          translate.storage.set('to', '')
          // 刷新页面恢复原文
          window.location.reload()
        }
      }
    }
  }
}
</script>

<style scoped>
/* @import '@/assets/css/style.css';
@import '@/assets/css/m-header.css'; */

/* PC端菜单选中状态 */
.web-navers dl h3 a.router-link-active {
  color: #1E61A5;
  border-bottom: 2px solid #1E61A5;
}
</style>
